package devxertech.com.theme
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgba
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

enum class Palette(
    val hexLight: String,
    val rgbLight: Color.Rgb,
    val hexDark: String,
    val rgbDark: Color.Rgb,
) {
    Primary(
        hexLight = "#0ABAB1",
        rgbLight = rgba( 10,  186,  177, 1f ),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    Secondary(
        hexLight = "#254D79",
        rgbLight = rgb(37, 77, 121),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    topBarButton(
        hexLight = "#1DCFC6",
        rgbLight = rgba(29, 207, 198, 1f),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    CareerBoxShadow(
        hexLight = "#254D79",
        rgbLight = rgba(37, 77, 121, 0.25f),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    BodyBackground(
        hexLight = "#F4F4F4",
        rgbLight = rgb(r = 244, g = 244, b = 244),
        hexDark = "#0F0819",
        rgbDark = rgb(15, 8, 25),
    ),

    TableHeader(
        hexLight = "#E0E0E0",
        rgbLight = rgb(r = 224, g = 224, b = 224),
        hexDark = "#0F0819",
        rgbDark = rgb(15, 8, 25),
    ),
    SearchbarPlaceholder(
        hexLight = "#A4A4A4",
        rgbLight = rgb(r = 164, g = 164, b = 164),
        hexDark = "#F7F7FA",
        rgbDark = rgb(247, 247, 250)
    ),

    Error(
        hexLight = "#B7182B",
        rgbLight = rgb(183, 24, 43),
        hexDark = "#E24A61",
        rgbDark = rgb(226, 74, 97)
    ),
    Red(
        hexLight = "#D85B6A",
        rgbLight = rgba(216, 91, 106, 1f),
        hexDark = "#E24A61",
        rgbDark = rgb(226, 74, 97)
    ),
    Success(
        hexLight = "#23A971",
        rgbLight = rgba(35, 169, 113, 1f),
        hexDark = "#219B65",
        rgbDark = rgba(33, 155, 101, 1f)
    ),
    EditTextBorder(
        hexLight = "#D4D4D4",
        rgbLight = rgb(212, 212, 212),
        hexDark = "#B9BCC2",
        rgbDark = rgb(185, 188, 194)
    ),
    EditTextSupportText(
        hexLight = "#424242",
        rgbLight = rgb(66, 66, 66),
        hexDark = "#94979C",
        rgbDark = rgb(148, 151, 156)
    ),
    ParrotGreen(
        hexLight = "#DAFD5D",
        rgbLight = rgb(218, 253, 93),
        hexDark = "#DAFD5D",
        rgbDark = rgb(218, 253, 93),
    ),
    ButtonTextSupportive(
        hexLight = "#787878",
        rgbLight = rgb(120, 120, 120),
        hexDark = "#F7F7FA",
        rgbDark = rgb(247, 247, 250)
    ),
    Disabled(
        hexLight = "#F4F4F4",
        rgbLight = rgba(244, 244, 244, 1f),
        hexDark = "#252132",
        rgbDark = rgba(37, 33, 50, 1f)
    ),
    Black(
        hexLight = "#000000",
        rgbLight = Colors.Black,
        hexDark = "#000000",
        rgbDark = Colors.Black,
    ),
    White(
        hexLight = "#FFFFFF",
        rgbLight = Colors.White,
        hexDark = "#FFFFFF",
        rgbDark = Colors.White,
    ),
    TextWhite(
        hexLight = "#FFFFFF",
        rgbLight = Colors.White,
        hexDark = "#FFFFFF",
        rgbDark = Colors.White,
    ),
    Modal(
        hexLight = "#FAFAFA",
        rgbLight = Colors.White,
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    BackendTech(
        hexLight = "#FBE2FF",
        rgbLight = rgba(251, 226, 255, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    FrontendTech(
        hexLight = "##EBECF2",
        rgbLight = rgba(235, 236, 242, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    DatabaseTech(
        hexLight = "#FFE9E9",
        rgbLight = rgba(255, 233, 233, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
        MobileTech(
        hexLight = "#D6F9F0",
        rgbLight = rgba(214, 249, 240, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    BlockChainTech(
        hexLight = "#FFEDD9",
        rgbLight =rgba(255, 237, 217, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    BlockChainBottom(
        hexLight = "#FFEDD9",
        rgbLight =rgba(255, 237, 217, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),

    DevOpsTech(
        hexLight = "#E8FCB2",
        rgbLight = rgba(232, 252, 178, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    FooterTextColor(
        hexLight = "#E8FCB2",
        rgbLight = rgba(232, 252, 178, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    HeaderGradient_One(
    hexLight = "#1CE0D576",
    rgbLight = rgba(232, 252, 178, 1f),
    hexDark = "#181222",
    rgbDark = rgb(24, 18, 34),
    ),
    HeaderGradient_Two(
    hexLight = "#16D6CB76",
    rgbLight = rgba(22, 214, 203, 1f),
    hexDark = "#181222",
    rgbDark = rgb(24, 18, 34),
    ),
    ContactUsBorder(
        hexLight = "#16D6CB29",
        rgbLight = rgba(22, 214, 203, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    LineBorder(
        hexLight = "#BEB6B6",
        rgbLight = rgba(190, 182, 182, 1),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    ContactLeftSec(
        hexLight = "#F7FAFD",
        rgbLight = rgba(247, 250, 253, 1f),
        hexDark = "#F7FAFD",
        rgbDark = rgba(247, 250, 253, 1f),
    ),
    ContactText(
        hexLight = "#636D78",
        rgbLight = rgba(99, 109, 120, 1f),
        hexDark = "#F7FAFD",
        rgbDark = rgba(247, 250, 253, 1f),
    ),
    ContactUsHeaderOne(
        hexLight = "#636D78",
        rgbLight = rgba(28, 224, 213, 0.7f),
        hexDark = "#F7FAFD",
        rgbDark = rgba(247, 250, 253, 1f),
    ),
    ContactUsHeaderTwo(
        hexLight = "#636D78",
        rgbLight = rgba(22, 214, 203, 0.7f),
        hexDark = "#F7FAFD",
        rgbDark = rgba(247, 250, 253, 1f),
    ),
    HeaderGradientOne(
        hexLight = "#35F5D2AC",
        rgbLight = rgba(53, 245, 210, 0.67f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    HeaderGradientTwo(
        hexLight = "#07AFA6E5",
        rgbLight = rgba(7, 175, 166, 0.9f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    HoverGradientTeam(
        hexLight = "#1DCAC0",
        rgbLight = rgba(29, 202, 192, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    HoverGradientOne(
        hexLight = "#61DABB",
        rgbLight = rgba(97, 218, 187, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    HoverGradientTwo(
        hexLight = "#0EB0A7",
        rgbLight = rgba(14, 176, 167, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    ClientFeedbackCount(
        hexLight = "#2A2B2C",
        rgbLight = rgba(42, 43, 44, 1f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    RatingSectionBackground(
        hexLight = "#F6F6F6",
        rgbLight = rgba(246, 246, 246, 0.81f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    SoftwareSectionBackground(
        hexLight = "#F8FBFF",
        rgbLight = rgba(248, 251, 255, 0.8f),
        hexDark = "#181222",
        rgbDark = rgb(24, 18, 34),
    ),
    TeamSectionBackground(
        hexLight = "#FAFAFA",
        rgbLight = rgba(250, 250, 250, 1f),
        hexDark = "#FAFAFA",
        rgbDark = rgb(24, 18, 34),
    ),
    TopBarMenuText(
        hexLight = "#1C3F60",
        rgbLight = rgba(28, 63, 96, 1f),
        hexDark = "#FAFAFA",
        rgbDark = rgb(24, 18, 34),
    ),
    SpecialButtonBorderColor(
        hexLight = "#F5FCFF",
        rgbLight = rgba(0, 0, 0, .14f),
        hexDark = "#FAFAFA",
        rgbDark = rgb(24, 18, 34),
    ),
    CareerPage(
        hexLight = "#F5FCFF",
        rgbLight = rgba(245, 252, 255, 1f),
        hexDark = "#FAFAFA",
        rgbDark = rgb(24, 18, 34),
    ),
    CareerLight(
        hexLight = "#19C4BA",
        rgbLight = rgba(25, 196, 186, 1f),
        hexDark = "#35D593",
        rgbDark = rgb(r = 53, g = 213, b = 147),

        ),
    SideBarDropDown(
        hexLight = "#9E9D9D",
        rgbLight = rgba(158, 157, 157, 1f),
        hexDark = "#35D593",
        rgbDark = rgba(158, 157, 157, 1f)
    ),
    BlogAbout(
        hexLight = "#17D2C817",
        rgbLight = rgba(23, 210, 200, 0.09f),
        hexDark = "#17D2C817",
        rgbDark = rgba(23, 210, 200, 0.09f)
    )



}


class SitePalette(
    // top level colors
    val primary: ColorVariation,
    val bodyBackground: ColorVariation,
    val bodyBackgroundSecondary: ColorVariation,

    // Button Colors
    val specialButtonBorderColor: ColorVariation,
    val commonButtonBorderColor: ColorVariation,
    val commonSecondaryButtonColor: ColorVariation,
    val commonButtonSupportiveTextColor: ColorVariation,

    // Header colors
    val headerBackgroundColor: ColorVariation,
    val tablehHeaderBackgroundColor: ColorVariation,


    // Text Field Colors
    val textFieldTextColor: ColorVariation,
    val textFieldSupportiveTextColor: ColorVariation,
    val textFieldBorderColor: ColorVariation,
    val textFieldBorderColorDisabled: ColorVariation,
    val searchbarBorderColorPlaceholder: ColorVariation,

    // Modal Colors
    val modalBackgroundColor: ColorVariation,


    // Other Text Colors
    val textErrorColor: ColorVariation,
    val textRedColor: ColorVariation,
    val textGreenColor: ColorVariation,
    val topBarMenuText: ColorVariation,
    val sideBarDropDown: ColorVariation,

    //Technologies Box Colors
    val backendTech: ColorVariation,
    val frontendTech: ColorVariation,
    val databaseTech: ColorVariation,
    val mobileTech: ColorVariation,
    val blockChainTech: ColorVariation,
    val devOpsTech: ColorVariation,
// Gradients
    val headerGradientOne: ColorVariation,
    val headerGradientTwo: ColorVariation,
    val hoverGradientTeam: ColorVariation,
    val hoverGradientOne: ColorVariation,
    val hoverGradientTwo: ColorVariation,
    val clientFeedbackCount: ColorVariation,



//    Contact Us Section
    val contactUsBorder: ColorVariation,
    val linecolor: ColorVariation,
    val contactLeft: ColorVariation,
    val contactText: ColorVariation,
    val contactUsHeaderOne: ColorVariation,
    val contactUsHeaderTwo: ColorVariation,
    val ratingSectionBackground: ColorVariation,
    val softwareSectionBackground: ColorVariation,
    val teamSectionBackground: ColorVariation,

//    Career Page
    val careerPage: ColorVariation,
    val careerLight: ColorVariation,

//    Blogs
    val blogPage: ColorVariation,

//    CommonButton
    val topBarButton: ColorVariation,


    ) {
    class ColorVariation(
        val hex: String,
        val rgb: Color.Rgb
    )
}

object SitePalettes {
    val light = SitePalette(
        // top level colors
        primary = SitePalette.ColorVariation(
            hex = Palette.Primary.hexLight,
            rgb = Palette.Primary.rgbLight
        ),
        bodyBackground = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexLight,
            rgb = Palette.BodyBackground.rgbLight

        ),
        bodyBackgroundSecondary = SitePalette.ColorVariation(
            hex = Palette.White.hexLight,
            rgb = Palette.White.rgbLight

        ),

        // Button colors
        specialButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.SpecialButtonBorderColor.hexLight,
            rgb = Palette.SpecialButtonBorderColor.rgbLight

        ),
        commonButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.Primary.hexLight,
            rgb = Palette.Primary.rgbLight

        ),
        commonSecondaryButtonColor = SitePalette.ColorVariation(
            hex = Palette.Secondary.hexLight,
            rgb = Palette.Secondary.rgbLight

        ),
        commonButtonSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.ButtonTextSupportive.hexLight,
            rgb = Palette.ButtonTextSupportive.rgbLight

        ),

        // Header colors

        headerBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.Primary.hexLight,
            rgb = Palette.Primary.rgbLight

        ),

        tablehHeaderBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.TableHeader.hexLight,
            rgb = Palette.TableHeader.rgbLight

        ),

        // Text Field colors
        textFieldTextColor = SitePalette.ColorVariation(
            hex = Palette.Black.hexLight,
            rgb = Palette.Black.rgbLight

        ),
        textFieldSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.EditTextSupportText.hexLight,
            rgb = Palette.EditTextSupportText.rgbLight

        ),
        textFieldBorderColorDisabled = SitePalette.ColorVariation(
            hex = Palette.Disabled.hexLight,
            rgb = Palette.Disabled.rgbLight

        ),
        textFieldBorderColor = SitePalette.ColorVariation(
            hex = Palette.EditTextBorder.hexLight,
            rgb = Palette.EditTextBorder.rgbLight

        ),
        searchbarBorderColorPlaceholder = SitePalette.ColorVariation(
            hex = Palette.SearchbarPlaceholder.hexLight,
            rgb = Palette.SearchbarPlaceholder.rgbLight

        ),

        // Modal background color
        modalBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.Modal.hexLight,
            rgb = Palette.Modal.rgbLight

        ),

        // Other text colors
        textErrorColor = SitePalette.ColorVariation(
            hex = Palette.Error.hexLight,
            rgb = Palette.Error.rgbLight

        ),

        textRedColor = SitePalette.ColorVariation(
            hex = Palette.Red.hexLight,
            rgb = Palette.Red.rgbLight

        ),
        textGreenColor = SitePalette.ColorVariation(
            hex = Palette.Success.hexLight,
            rgb = Palette.Success.rgbLight

        ),
//        Tech box Colors

        backendTech = SitePalette.ColorVariation(
            hex = Palette.BackendTech.hexLight,
            rgb = Palette.BackendTech.rgbLight
        ),
        frontendTech = SitePalette.ColorVariation(
            hex = Palette.FrontendTech.hexLight,
            rgb = Palette.FrontendTech.rgbLight
        ),
        databaseTech = SitePalette.ColorVariation(
            hex = Palette.DatabaseTech.hexLight,
            rgb = Palette.DatabaseTech.rgbLight
        ),
        mobileTech = SitePalette.ColorVariation(
            hex = Palette.MobileTech.hexLight,
            rgb = Palette.MobileTech.rgbLight
        ),
        blockChainTech = SitePalette.ColorVariation(
            hex = Palette.BlockChainTech.hexLight,
            rgb = Palette.BlockChainTech.rgbLight
        ),
        devOpsTech = SitePalette.ColorVariation(
            hex = Palette.DevOpsTech.hexLight,
            rgb = Palette.DevOpsTech.rgbLight
        ),
        contactUsBorder = SitePalette.ColorVariation(
            hex = Palette.ContactUsBorder.hexLight,
            rgb = Palette.ContactUsBorder.rgbLight
        ),
        linecolor = SitePalette.ColorVariation(
            hex = Palette.LineBorder.hexLight,
            rgb = Palette.LineBorder.rgbLight
        ),
        contactLeft = SitePalette.ColorVariation(
            hex = Palette.ContactLeftSec.hexLight,
            rgb = Palette.ContactLeftSec.rgbLight
        ),
        contactText = SitePalette.ColorVariation(
            hex = Palette.ContactText.hexLight,
            rgb = Palette.ContactText.rgbLight
        ),
        contactUsHeaderOne = SitePalette.ColorVariation(
            hex = Palette.ContactUsHeaderOne.hexLight,
            rgb = Palette.ContactUsHeaderOne.rgbLight
        ),
        contactUsHeaderTwo = SitePalette.ColorVariation(
            hex = Palette.ContactUsHeaderTwo.hexLight,
            rgb = Palette.ContactUsHeaderTwo.rgbLight
        ),
        headerGradientOne = SitePalette.ColorVariation(
            hex = Palette.HeaderGradientOne.hexLight,
            rgb = Palette.HeaderGradientOne.rgbLight
        ),
        headerGradientTwo = SitePalette.ColorVariation(
            hex = Palette.HeaderGradientTwo.hexLight,
            rgb = Palette.HeaderGradientTwo.rgbLight
        ),
        hoverGradientOne = SitePalette.ColorVariation(
            hex = Palette.HoverGradientOne.hexLight,
            rgb = Palette.HoverGradientOne.rgbLight
        ),
        hoverGradientTwo = SitePalette.ColorVariation(
            hex = Palette.HoverGradientTwo.hexLight,
            rgb = Palette.HoverGradientTwo.rgbLight
        ),
        clientFeedbackCount = SitePalette.ColorVariation(
            hex = Palette.ClientFeedbackCount.hexLight,
            rgb = Palette.ClientFeedbackCount.rgbLight
        ),
        ratingSectionBackground = SitePalette.ColorVariation(
            hex = Palette.RatingSectionBackground.hexLight,
            rgb = Palette.RatingSectionBackground.rgbLight
        ),
        softwareSectionBackground = SitePalette.ColorVariation(
            hex = Palette.SoftwareSectionBackground.hexLight,
            rgb = Palette.SoftwareSectionBackground.rgbLight
        ),
        teamSectionBackground = SitePalette.ColorVariation(
            hex = Palette.TeamSectionBackground.hexLight,
            rgb = Palette.TeamSectionBackground.rgbLight
        ),
        topBarMenuText = SitePalette.ColorVariation(
            hex = Palette.TopBarMenuText.hexLight,
            rgb = Palette.TopBarMenuText.rgbLight
        ),
        careerPage = SitePalette.ColorVariation(
            hex = Palette.CareerPage.hexLight,
            rgb = Palette.CareerPage.rgbLight
        ),
        careerLight = SitePalette.ColorVariation(
            hex = Palette.CareerLight.hexLight,
            rgb = Palette.CareerLight.rgbLight
        ),
        topBarButton = SitePalette.ColorVariation(
            hex = Palette.topBarButton.hexLight,
            rgb = Palette.topBarButton.rgbLight
        ),
        sideBarDropDown = SitePalette.ColorVariation(
            hex = Palette.SideBarDropDown.hexLight,
            rgb = Palette.SideBarDropDown.rgbLight
        ),
        hoverGradientTeam = SitePalette.ColorVariation(
            hex = Palette.HoverGradientTeam.hexLight,
            rgb = Palette.HoverGradientTeam.rgbLight
        ),
        blogPage = SitePalette.ColorVariation(
            hex = Palette.BlogAbout.hexLight,
            rgb = Palette.BlogAbout.rgbLight
        )

    )

    val dark = SitePalette(
        // top level colors
        primary = SitePalette.ColorVariation(
            hex = Palette.Primary.hexDark,
            rgb = Palette.Primary.rgbDark
        ),
        bodyBackground = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexDark,
            rgb = Palette.BodyBackground.rgbDark

        ),
        bodyBackgroundSecondary = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexDark,
            rgb = Palette.BodyBackground.rgbDark

        ),

        // Button colors
        specialButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.SpecialButtonBorderColor.hexDark,
            rgb = Palette.SpecialButtonBorderColor.rgbDark

        ),
        commonButtonBorderColor = SitePalette.ColorVariation(
            hex = Palette.Primary.hexDark,
            rgb = Palette.Primary.rgbDark

        ),
        commonSecondaryButtonColor = SitePalette.ColorVariation(
            hex = Palette.Secondary.hexDark,
            rgb = Palette.Secondary.rgbDark

        ),
        commonButtonSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.ButtonTextSupportive.hexDark,
            rgb = Palette.ButtonTextSupportive.rgbDark

        ),

        // Header colors

        headerBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.BodyBackground.hexDark,
            rgb = Palette.BodyBackground.rgbDark

        ),

        tablehHeaderBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.TableHeader.hexDark,
            rgb = Palette.TableHeader.rgbDark

        ),


        // Text Field colors
        textFieldTextColor = SitePalette.ColorVariation(
            hex = Palette.White.hexDark,
            rgb = Palette.White.rgbDark

        ),
        textFieldSupportiveTextColor = SitePalette.ColorVariation(
            hex = Palette.EditTextSupportText.hexDark,
            rgb = Palette.EditTextSupportText.rgbDark

        ),
        textFieldBorderColorDisabled = SitePalette.ColorVariation(
            hex = Palette.Disabled.hexDark,
            rgb = Palette.Disabled.rgbDark

        ),
        textFieldBorderColor = SitePalette.ColorVariation(
            hex = Palette.EditTextBorder.hexDark,
            rgb = Palette.EditTextBorder.rgbDark

        ),
        searchbarBorderColorPlaceholder = SitePalette.ColorVariation(
            hex = Palette.SearchbarPlaceholder.hexDark,
            rgb = Palette.SearchbarPlaceholder.rgbDark

        ),

        // Modal background color
        modalBackgroundColor = SitePalette.ColorVariation(
            hex = Palette.Modal.hexDark,
            rgb = Palette.Modal.rgbDark

        ),

        // Other text colors
        textErrorColor = SitePalette.ColorVariation(
            hex = Palette.Error.hexDark,
            rgb = Palette.Error.rgbDark

        ),

        textRedColor = SitePalette.ColorVariation(
            hex = Palette.Red.hexDark,
            rgb = Palette.Red.rgbDark

        ),
        textGreenColor = SitePalette.ColorVariation(
            hex = Palette.Success.hexDark,
            rgb = Palette.Success.rgbDark

        ),
        backendTech = SitePalette.ColorVariation(
            hex = Palette.BackendTech.hexDark,
            rgb = Palette.BackendTech.rgbDark
        ),
        frontendTech = SitePalette.ColorVariation(
            hex = Palette.FrontendTech.hexDark,
            rgb = Palette.FrontendTech.rgbDark
        ),
        databaseTech = SitePalette.ColorVariation(
            hex = Palette.DatabaseTech.hexDark,
            rgb = Palette.DatabaseTech.rgbDark
        ),
        mobileTech = SitePalette.ColorVariation(
            hex = Palette.MobileTech.hexDark,
            rgb = Palette.MobileTech.rgbDark
        ),
        blockChainTech = SitePalette.ColorVariation(
            hex = Palette.BlockChainTech.hexDark,
            rgb = Palette.BlockChainTech.rgbDark
        ),
        devOpsTech = SitePalette.ColorVariation(
            hex = Palette.DevOpsTech.hexDark,
            rgb = Palette.DevOpsTech.rgbDark
        ),
        contactUsBorder = SitePalette.ColorVariation(
            hex = Palette.ContactUsBorder.hexDark,
            rgb = Palette.ContactUsBorder.rgbDark
        ),
        linecolor = SitePalette.ColorVariation(
            hex = Palette.LineBorder.hexDark,
            rgb = Palette.LineBorder.rgbDark
        ),
        contactLeft = SitePalette.ColorVariation(
            hex = Palette.ContactLeftSec.hexDark,
            rgb = Palette.ContactLeftSec.rgbDark
        ),
        contactText = SitePalette.ColorVariation(
            hex = Palette.ContactText.hexDark,
            rgb = Palette.ContactText.rgbDark
        ),
        contactUsHeaderOne = SitePalette.ColorVariation(
            hex = Palette.ContactUsHeaderOne.hexDark,
            rgb = Palette.ContactUsHeaderOne.rgbDark
        ),
        contactUsHeaderTwo = SitePalette.ColorVariation(
            hex = Palette.ContactUsHeaderTwo.hexDark,
            rgb = Palette.ContactUsHeaderTwo.rgbDark
        ),
        headerGradientOne = SitePalette.ColorVariation(
            hex = Palette.HeaderGradientOne.hexDark,
            rgb = Palette.HeaderGradientOne.rgbDark
    ),
        headerGradientTwo = SitePalette.ColorVariation(
            hex = Palette.HeaderGradientTwo.hexDark,
            rgb = Palette.HeaderGradientTwo.rgbDark
        ),
        hoverGradientOne = SitePalette.ColorVariation(
            hex = Palette.HoverGradientOne.hexDark,
            rgb = Palette.HoverGradientOne.rgbDark
    ),
        hoverGradientTwo = SitePalette.ColorVariation(
            hex = Palette.HoverGradientTwo.hexDark,
            rgb = Palette.HoverGradientTwo.rgbDark
        ),
        clientFeedbackCount = SitePalette.ColorVariation(
            hex = Palette.ClientFeedbackCount.hexDark,
            rgb = Palette.ClientFeedbackCount.rgbDark
    ),
        ratingSectionBackground = SitePalette.ColorVariation(
            hex = Palette.RatingSectionBackground.hexDark,
            rgb = Palette.RatingSectionBackground.rgbDark
        ),
        softwareSectionBackground = SitePalette.ColorVariation(
            hex = Palette.SoftwareSectionBackground.hexDark,
            rgb = Palette.SoftwareSectionBackground.rgbDark
        ),
        teamSectionBackground = SitePalette.ColorVariation(
            hex = Palette.TeamSectionBackground.hexDark,
            rgb = Palette.TeamSectionBackground.rgbDark
        ),
        topBarMenuText = SitePalette.ColorVariation(
            hex = Palette.TopBarMenuText.hexDark,
            rgb = Palette.TopBarMenuText.rgbDark
        ),
        careerPage = SitePalette.ColorVariation(
            hex = Palette.CareerPage.hexDark,
            rgb = Palette.CareerPage.rgbDark
        ),
        careerLight = SitePalette.ColorVariation(
            hex = Palette.CareerLight.hexDark,
            rgb = Palette.CareerLight.rgbDark
        ),
        topBarButton = SitePalette.ColorVariation(
            hex = Palette.topBarButton.hexDark,
            rgb = Palette.topBarButton.rgbDark
        ),
        sideBarDropDown = SitePalette.ColorVariation(
            hex = Palette.SideBarDropDown.hexDark,
            rgb = Palette.SideBarDropDown.rgbDark
    ),
        hoverGradientTeam = SitePalette.ColorVariation(
            hex = Palette.HoverGradientTeam.hexDark,
            rgb = Palette.HoverGradientTeam.rgbDark
        ),
        blogPage = SitePalette.ColorVariation(
            hex = Palette.BlogAbout.hexDark,
            rgb = Palette.BlogAbout.rgbDark
        )
    )

}


val LocalColorMode = compositionLocalOf { ColorMode.LIGHT }

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Palette.BodyBackground.rgbLight
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = Palette.BodyBackground.rgbDark
    ctx.theme.palettes.dark.color = Colors.White
}
